"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var LinkButton_1 = __importDefault(require("../../../../Button/LinkButton"));
var utils_1 = require("../utils");
var AddressResult_1 = __importDefault(require("./AddressResult"));
var styles = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #e5ebf0;\n  padding: 2em;\n\n  ", " {\n    background: #ffffff;\n  }\n"], ["\n  background-color: #e5ebf0;\n  padding: 2em;\n\n  ", " {\n    background: #ffffff;\n  }\n"])), AddressResult_1.default);
var SText = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 1em;\n"], ["\n  margin: 1em;\n"])));
var AddressResultList = function (_a) {
    var className = _a.className, addressResults = _a.addressResults, onSelect = _a.onSelect;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(SText, null,
            react_1.default.createElement("strong", null, "Zadan\u00FDm parametr\u016Fm pro ztoto\u017En\u011Bn\u00ED odpov\u00EDd\u00E1 v\u00EDce v\u00FDsledk\u016F."),
            react_1.default.createElement("br", null),
            "Zvolte jeden z nich, nebo zadejte dal\u0161\u00ED parametry pro ov\u011B\u0159en\u00ED adresy."),
        addressResults.map(function (addressResult) { return (react_1.default.createElement(AddressResult_1.default, { key: addressResult.ruian },
            utils_1.getAddressLabel(addressResult),
            react_1.default.createElement(LinkButton_1.default, { type: "button", className: "button", onClick: function () { return onSelect(addressResult); } }, "vybrat"))); })));
};
AddressResultList.defaultProps = {
    className: undefined,
};
exports.default = styled_components_1.default(AddressResultList)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles);
var templateObject_1, templateObject_2, templateObject_3;
